type getSnippetWithParamsProps = {
  html: string;
  paramsMap: Record<string, string>;
};

export const getSnippetWithParams = ({
  html,
  paramsMap
}: getSnippetWithParamsProps): string => {
  const matches = html.match(/{(\d+)}/g) || [];

  return matches.reduce((acc, item) => {
    const match = item.match(/{(\d+)}/);

    if (!match) {
      return acc;
    }

    const num = match[1];
    return acc.replace(item, paramsMap[num] || '');
  }, html);
};
